import thumbnailPlaceholder from './thumbnail-placeholder.webp';

export default {
  thumbnailPlaceholder,
};
